import React, { useEffect, useRef } from 'react';
import { FaTelegramPlane, FaVk } from 'react-icons/fa';
import '../assets/css/payment-notice.css';

export default function PaymentNoticeModal({ onClose, title = 'Сообщить об оплате' }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    const trigger = document.activeElement;
    const body = document.body;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const properties = ['position', 'top', 'left', 'width', 'overflow'];
    const previous = properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]);
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = `-${scrollX}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    dialog.showModal();
    return () => {
      dialog.close();
      previous.forEach(([name, value, priority]) => {
        if (value) body.style.setProperty(name, value, priority);
        else body.style.removeProperty(name);
      });
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    };
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className="payment-notice"
      aria-labelledby="payment-notice-title"
      aria-describedby="payment-notice-subtitle"
      onKeyDown={event => {
        if (event.key !== 'Tab') return;
        const items = event.currentTarget.querySelectorAll('button, a[href]');
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }}
      onCancel={event => { event.preventDefault(); onClose(); }}
      onClick={event => { if (event.target === event.currentTarget) onClose(); }}
    >
      <div className="payment-notice__panel">
        <button type="button" className="payment-notice__close" onClick={onClose} aria-label="Закрыть окно">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
        </button>
        <h2 id="payment-notice-title">{title}</h2>
        <p id="payment-notice-subtitle">Выберите удобный мессенджер</p>
        <div className="payment-notice__links">
          <a className="payment-notice__link payment-notice__link--telegram" href="https://t.me/kupivamerike_bot?start=2490149489" target="_blank" rel="noopener noreferrer">
            <span className="payment-notice__icon"><FaTelegramPlane aria-hidden="true" /></span>
            <span>Telegram</span><span className="payment-notice__arrow" aria-hidden="true">↗</span>
          </a>
          <a className="payment-notice__link payment-notice__link--max" href="https://max.ru/id772310727548_bot?start=2490149489" target="_blank" rel="noopener noreferrer">
            <span className="payment-notice__icon"><svg viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" fillRule="evenodd" d="M16 3C8.8 3 3 8.4 3 15.2c0 3.1.9 5.6 2.6 7.8L4.5 29l6.5-2.1c1.5.5 3.2.8 5 .8 7.2 0 13-5.5 13-12.5S23.2 3 16 3Zm0 6.2c3.6 0 6.4 2.7 6.4 6.1 0 3.5-2.8 6.2-6.4 6.2-1.1 0-2-.2-2.9-.7l-2.8.8.5-2.7c-.8-1-1.2-2.2-1.2-3.6 0-3.4 2.8-6.1 6.4-6.1Z" /></svg></span>
            <span>MAX</span><span className="payment-notice__arrow" aria-hidden="true">↗</span>
          </a>
          <a className="payment-notice__link payment-notice__link--vk" href="https://vk.com/write-218300265?ref=2490149489" target="_blank" rel="noopener noreferrer">
            <span className="payment-notice__icon"><FaVk aria-hidden="true" /></span>
            <span>ВКонтакте</span><span className="payment-notice__arrow" aria-hidden="true">↗</span>
          </a>
        </div>
        <p className="payment-notice__note">Если один мессенджер недоступен, выберите другой</p>
        <p className="payment-notice__note">Мессенджер откроется отдельно. Чтобы выбрать другой, вернитесь на эту вкладку — список останется открытым.</p>
      </div>
    </dialog>
  );
}
